import React, { Fragment, memo, useEffect, useRef, useState } from "react";
import { CCollapse } from "@coreui/react";
import { adminUsersApi } from "../api";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import Table from "../../../../components/table/coreUiTable/Table";
import { MainModal } from "../../../../components/modal/MainModal";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

export const EmailsTable = memo(function Info({ id }) {
  const [info, setInfo] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const [emailBody, setEmailBody] = useState(null);
  const abortControllerRef = useRef();

  async function fetchEmails() {
    try {
      abortControllerRef.current = new AbortController();
      const { data } = await adminUsersApi.getEmails({
        signal: abortControllerRef.current?.signal,
        params: { id }
      });
      setInfo(data);
    } catch (err) {
      console.log(err);
    }
  }

  async function fetchEmailInfo(emailId) {
    setIsOpen(true);
    try {
      const { data } = await adminUsersApi.getEmailBody({
        params: { id, email_id: emailId }
      });

      setEmailBody(data ? data : "<p>No Info</p>");
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (id) {
      fetchEmails();
    }

    return () => {
      abortControllerRef.current?.abort();
    };
  }, [id]);

  const onClose = () => {
    setIsOpen(false);
    setEmailBody(null);
  };

  return (
    <>
      <CCollapse show>
        <div>
          {info ? (
            <div className="admin-users__email">
              <Table
                table={{ colHeaders: info.colHeaders, data: info.data }}
                tableFilter={false}
                overrideColumnCallback={(header) => {
                  return {
                    _style: header === "Email ID" ? { display: "none" } : {}
                  };
                }}
                extraColumns={[{ key: "action", label: "" }]}
                scopedSlots={{
                  "Email ID": () => <td style={{ display: "none" }} />,
                  "Sent At": (item) => <td> {dayjs().to(dayjs(item["Sent At"]))} </td>,
                  action: (item) => {
                    let show = dayjs().diff(dayjs(item["Sent At"]), "day") <= 29;
                    return (
                      <td
                        onClick={show ? () => fetchEmailInfo(item["Email ID"]) : null}
                        style={{
                          cursor: show ? "pointer" : "not-allowed"
                        }}
                      >
                        View
                      </td>
                    );
                  }
                }}
              />
            </div>
          ) : (
            <LoadingAnimation uiLoader />
          )}
        </div>
      </CCollapse>

      <MainModal
        isOpen={isOpen}
        parentSelector=".admin-users"
        containerClassName="email"
        headerCloseHandler={onClose}
        onClose={onClose}
        width="100vw"
        height="100vh"
        isLoading={!emailBody}
        headerText="Email Body"
        renderFooter={() => null}
      >
        <div dangerouslySetInnerHTML={{ __html: emailBody }} />
      </MainModal>
    </>
  );
});
